function groupPointsByUnit(rows, unit, getBucketStart) {
    const buckets = new Map();

    for (const row of rows || []) {
        const date = getBucketStart(row.date, unit);
        const key = date.getTime();
        if (!buckets.has(key)) {
            buckets.set(key, { date: date.toISOString(), totals: {} });
        }
        const bucket = buckets.get(key);
        for (const [stage, value] of Object.entries(row.scoreTotals || {})) {
            if (!bucket.totals[stage]) bucket.totals[stage] = { points: 0, maximum: 0 };
            bucket.totals[stage].points += Number(value.points || 0);
            bucket.totals[stage].maximum += Number(value.maximum || 0);
        }
    }

    return Array.from(buckets.values()).sort((a, b) => Date.parse(a.date) - Date.parse(b.date)).map(bucket => {
        const points = {};
        for (const [stage, value] of Object.entries(bucket.totals)) {
            if (value.maximum > 0) points[stage] = Math.min(100, Math.round(value.points / value.maximum * 100));
        }
        return { date: bucket.date, points };
    });
}

module.exports = { groupPointsByUnit };
